<style scoped type="text/css">
.upload-csv-lable {
  height: 45px;
  width: 100%;
}
</style>

<template>
  <div>
    <v-row class="mb-4">
      <v-col class="mt-2" cols="9" md="8">
        <div
            v-for="(item, i) in user_type_list"
            :key="i"
            :class="
            filter_agent_type.agent_type == item
              ? 'elevation-1 border-rounded'
              : 'elevation-0'
          "
            class="filter-btn status-text-filter px-4 py-1 mx-2 cursor-pointer"
            @click="getAgentList(item)"
        >
          {{ item }}
        </div>
      </v-col>
      <v-col class="mt-1 text-right" cols="3" md="4">
        <span
            class="cursor-pointer"
            @click="
            $router.push({
              name: 'add-an-agent',
              query: { agent_type: encript(filter_agent_type) },
            })
          "
        >
          <span class="secodry-text-4 mr-3">{{
              $lang.ADD_AN_AGENT.toUpperCase()
            }}</span>
          <v-btn color="primary" depressed fab small>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </span>
      </v-col>

      <v-col cols="9" md="6">
        <v-text-field
            v-model="search_query"
            :placeholder="$lang.AGENT_SEARCH"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            rounded
            @keyup="getAgentList(filter_agent_type.agent_type)"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
        :disable-sort="true"
        :headers="headers"
        :hide-default-footer="true"
        :items="agent_list"
        :items-per-page="$keys.PAGE_LENGTH"
        :loading="table_loading"
        class="elevation-1 custome-header-bg custome-table-body"
        item-key="agent_id"
    >
      <template v-slot:item.agent_type="{ item }">
        <div>
          <img
              v-if="item.agent_type == $keys.PICKUP_AGENT"
              alt=""
              src="@/assets/pickup-agent.svg"
          />
          <img
              v-if="item.agent_type == $keys.DELIVERY_AGENT"
              alt=""
              src="@/assets/delivery-agent.svg"
          />
          <img
              v-if="item.agent_type == $keys.WAREHOUSE_AGENT"
              alt=""
              src="@/assets/wholesaler-agent.svg"
          />
        </div>
      </template>
      <template v-slot:item.access="{ item }">
        <div>
          <v-switch
              v-model="item.is_active"
              :class="
              item.is_active ? 'active-toggle-btn' : 'deactive-toggle-btn'
            "
              :ripple="false"
              class="custome-toggle-btn"
              color="error"
              inset
              @click="changeAgentStatus(item)"
          ></v-switch>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn fab small text @click="gotoAgentDetails(item)">
          <img alt="" src="@/assets/arrow-right.svg"/>
        </v-btn>
      </template>
      <!-- empty state -->
      <template v-slot:no-data>
        <empty-list :message="$lang.EMPTY_AGENT" :type="$keys.EMPTY_TYPE_2"/>
      </template>
    </v-data-table>

    <!-- pginations -->
    <v-pagination
        v-model="page_number"
        :length="total_page_count"
        :total-visible="7"
        class="custome-pagination"
        @input="getAgentList(filter_agent_type.agent_type)"
    ></v-pagination>
  </div>
</template>

<script type="text/javascript">
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      page_number: 1,
      total_page_count: 1,
      search_query: "",
      table_loading: false,
      agent_list: [],
      headers: [
        {text: "Name", align: "start", sortable: false, value: "agent_name"},
        {text: "Mobile", value: "agent_phone_number"},
        {text: "Address", value: "agent_address"},
        {text: "Rank", value: "agent_rank"},
        {text: "Type", value: "agent_type"},
        {text: "Wallet Amount", value: "wallet_amount"},
        {text: "Access", value: "access"},
        {text: "", value: "action"},
      ],
      user_type_list: [
        "All",
        "Pickup Agent",
        "Delivery Agent",
        "Warehouse Agent",
      ],
      //   filter_agent_type: "All",
      dialog: {
        flag: false,
        agent: null,
      },
    };
  },
  computed: mapGetters({
    filter_agent_type: "team/getAgentTypeFilter",
  }),
  created() {
    this.getAgentList(this.filter_agent_type.agent_type, false);
  },
  methods: {
    /* get agent list   */
    getAgentList(status, is_cancel = true) {
      const self = this;

      console.log(self.filter_agent_type.agent_type.agent_type)

      this.$store.dispatch("team/setAgentTypeFilter", {agent_type: status});
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.search_query,
      };
      if (self.filter_agent_type.agent_type != "All") {
        params.filter_agent_type = JSON.stringify([self.filter_agent_type.agent_type]);
      }
      self.table_loading = true;
      const successHandler = (response) => {
        self.agent_list = response.data.agent_list;
        self.total_page_count = response.data.total_page_count;
      };
      const finallyHandler = () => {
        self.table_loading = false;
      };
      self.request_GET(
          self,
          self.$urls.AGENT_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler,
          is_cancel
      );
    },
    /* goto Agdent details */
    gotoAgentDetails(agent) {
      this.$router.push({
        name: "employee-details",
        params: {agent_id: this.encript(agent.id)},
      });
    },
    /*confirm change status Option */
    confirm_chnage_agent_status(agent) {
      this.dialog.flag = true;
      this.dialog.agent = agent;
    },
    /* referesh data */
    refreshData() {
      this.dialog.flag = false;
      this.dialog.agent = null;
      this.getAgentList("All");
    },
    /* change the agent status  enable/ disable */
    changeAgentStatus(agent) {
      const self = this;
      var form = new FormData();
      let is_active = "False";
      if (agent.is_active) is_active = "True";

      form.append("id", agent.id);
      form.append("is_active", is_active);

      const successHandler = (response) => {
        if (response.data.success) {
          self.getAgentList(self.filter_agent_type);
        }
      };
      const finallyHandler = () => {
        self.btn_loading = false;
      };

      this.request_POST(
          self,
          self.$urls.CHANGE_AGENT_STATUS,
          form,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },
  },
};
</script>